module.exports = __webpack_public_path__ + "61f6a06be26b9b79fe2c1b0b22d2552a.svg";